// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"2a9c7044","681":"2a9c7044"}[chunkId] + ".chunk.css";
};